/**
 * Propietarios de una tienda: la lista llega unas veces como objetos
 * `{id, name, email}` y otras como UUIDs sueltos. Normalizarlo una vez evita
 * repetir el mismo `owner.name || owner.email || …` en tarjeta y tabla.
 */
export function ownerNames(owners) {
  if (!Array.isArray(owners)) return [];
  return owners
    .filter((owner) => owner && (owner.id || typeof owner === 'string'))
    .map((owner, index) => owner.name || owner.email || `Propietario ${index + 1}`);
}

/** Texto plano para celdas estrechas. */
export function ownersSummary(owners, { max = 3 } = {}) {
  const names = ownerNames(owners);
  if (names.length === 0) return null;
  if (names.length <= max) return names.join(', ');
  return `${names.slice(0, max).join(', ')} +${names.length - max}`;
}
